module.exports = __webpack_public_path__ + "img/firefly.be5030ca.webp";